// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"tree-qr-reader_wrapper__iZfcx","card":"tree-qr-reader_card__2TYbs","qr-reader":"tree-qr-reader_qr-reader__GsHi-"};